import { performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { toErrorId, toErrorMessage } from '@atlassian/jira-project-settings-apps-common/src/types';
import { famaCatchAndLogFetchError } from '@atlassian/jira-project-settings-apps-common/src/util/catch-and-log-fetch-error';
import { PACKAGE_NAME } from '../../model/constants';
import type { ProjectContext, ProjectTeamType } from './types';

export const updateProjectTeamTypeEndpoint = (context: ProjectContext): string =>
	`/rest/servicedesk/latest/project/properties/${String(context.projectId)}/teamType`;

const updateProjectTeamTypeDetails = (
	context: ProjectContext,
	details: ProjectTeamType,
): Promise<ProjectTeamType> =>
	famaCatchAndLogFetchError(
		performPutRequest(updateProjectTeamTypeEndpoint(context), {
			body: JSON.stringify(details),
		}),
		PACKAGE_NAME,
		toErrorId('updateProjectTeamType'),
		toErrorMessage('Failed to update project team type'),
	);

export default updateProjectTeamTypeDetails;
